import { render, staticRenderFns } from "./ReferenceFormHeader.vue?vue&type=template&id=773b9156&scoped=true&"
import script from "./ReferenceFormHeader.vue?vue&type=script&lang=ts&"
export * from "./ReferenceFormHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ReferenceFormHeader.vue?vue&type=style&index=0&id=773b9156&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773b9156",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRadio,VRadioGroup,VRow})
